import * as types from './constants';

const initialState = {
  data: {},
  getLoading: false,
  editLoading: false,
  errors_api: {}
};

const actions = {
  // Get Merchant By Id
  [types.GET_MERCHANT_BY_ID_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_MERCHANT_BY_ID_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.GET_MERCHANT_BY_ID_FAILED]: state => {
    const data = {
      ...state,
      getLoading: false
    };

    return { ...data };
  },
  
  // Edit Merchant
  [types.EDIT_MERCHANT_REQUEST]: state => {
    const data = {
      ...state,
      editLoading: true
    };

    return { ...data };
  },

  [types.EDIT_MERCHANT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      editLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.EDIT_MERCHANT_FAILED]: state => {
    const data = {
      ...state,
      editLoading: false
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

